import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button"; // Import Button
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import DataTable from "common/Tables/DataTable";
import linesGenerationTableData from "layouts/tables/data/linesGenerationTableData";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGenerations } from "store/slice/linesGeneration";
import { useState } from "react";
import GenerationModal from "./generationModal";
import { deleteLineGeneration } from "store/slice/linesGeneration";

function LinesGeneration() {
  const genStore = useSelector((store) => store.linesGeneration);
  const navigate = useNavigate();

  const [isOpenModal, setIsOpenModal] = useState(false);

  const openShiftGeneration = () => {
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  }

  const editAction = (game) => {
    navigate(`/linesGeneration/${game.id}`);
  };
  
  const deteleAction = (game) => {
    dispatch(deleteLineGeneration(game.id));
  };

  const { columns, rows } = linesGenerationTableData({
    generations: genStore.generations,
    editAction,
    deteleAction
  }); 
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGenerations());
  }, []);

  const handleAddGame = () => {
    navigate("/linesGeneration/new"); // Navigate to the page to create a new game
  };
  return (

    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid spacing={6}>
          <Grid size={{xs: 12}}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Lines
                </MDTypography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={openShiftGeneration}
                >
                  Generate lines
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <GenerationModal 
        isOpen={isOpenModal} 
        handleModalClose={closeModal}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default LinesGeneration;
